import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        questions: '=',
        list: '=',
        form: '='
    },
    template
})

export default class {
    constructor ($rootScope, $translate, lodash, toastr, DATATABLES, ModalService, FormService, FormResource, FORMS_TYPE_ENUM) {
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.FormService = FormService;
        this.FormResource = FormResource;
        this.FORMS_TYPE_ENUM = FORMS_TYPE_ENUM;
    }

    $onInit () {
        this.canManageQuestion = this.FormService.canManageForm(this.form);
        this.sortableOptions = {
            handle: '.ico-move',
            stop: () => this.updateSequence()
        };
        this.isCertificationForm = this.form.type === this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION;
    }

    getFormQuestion (question) {
        return question.formQuestions.find(fq => fq.formId === this.form.id);
    }

    updateSequence () {
        const questionIds = this.questions.map(item => item.id);

        this.FormResource.updateQuestionSequence({
            questionIds,
            formId: this.form.id
        }).$promise
            .then(() => this.toastr.success(this.$translate.instant('forms.Question sequence updated')))
            .catch(() => this.toastr.error(this.$translate.instant('forms.Question sequence failed')));
    }

    updateMandatory (question) {
        const message = this.$translate.instant('forms.You changed the mandatory state of the question {questionName}', {
            questionName: question.nameWithoutHtml
        });

        const formQuestion = this.getFormQuestion(question);

        const post = {
            formId: this.form.id,
            questionId: question.id,
            isRequired: formQuestion.isRequired
        };

        this.ModalService.confirm(message)
            .then(() => {
                this.FormResource.updateQuestion({ id: formQuestion.id }, post).$promise
                    .then(() => this.toastr.success(this.$translate.instant('forms.Mandatory state of question changed')))
                    .catch(() => {
                        this.revertMandatory(question);
                        this.toastr.error(this.$translate.instant('forms.Question mandatory update failed'));
                    });
            })
            .catch(() => this.revertMandatory(question));
    }

    /**
     * Revert toggle because saving was unsuccessful
     * @param question
     */
    revertMandatory (question) {
        const fq = this.getFormQuestion(question);
        fq.isRequired = !fq.isRequired;
    }

    updateQuestion (question) {
        const { form, $rootScope } = this;
        return this.ModalService.open({
            template: `
                <modals-question-add
                    class="wrapper"
                    question="vm.question"
                    sites="vm.sites"
                    form-model="vm.formModel"
                    uib-modal-instance="vm.$uibModalInstance"
                />
            `,
            resolve: {
                sites: (SiteResource) => {
                    return SiteResource.query({
                        formSites: true,
                        fields: 'id,name',
                        pageSize: 0
                    }).$promise;
                }
            },
            controller (sites, $uibModalInstance, QuestionResource) {
                this.sites = sites;
                this.$uibModalInstance = $uibModalInstance;
                // make sure question has resource functions
                this.question = new QuestionResource(question);
                this.formModel = form;
            },
            size: 'xlarge'
        }).then(() => $rootScope.$broadcast('updateQuestion'));
    }

    removeQuestion (question) {
        const questionId = question.id;

        this.FormResource.deleteFormQuestion({ questionId, formId: this.form.id, validateOnly: true }).$promise
            .then(() => {
                this.ModalService.delete(this.$translate.instant('forms.Are you sure you want to remove this question from form?'))
                    .then(() => {
                        this.FormResource.deleteFormQuestion({ questionId, formId: this.form.id }).$promise
                            .then(() => {
                                this.toastr.success(this.$translate.instant('forms.Question is removed from form'));
                                this.$rootScope.$broadcast('updateQuestion');
                            }).catch((response) => {
                                this.showRemoveError(response && response.data);
                            });
                    });
            })
            .catch((errors) => {
                const assessmentWarning = this.lodash.find(errors.data, (error) => error.field === 'ASSESSMENT_VIRTUAL_ATTR');
                const assessmentError = this.lodash.find(errors.data, (error) => error.field === 'ERROR_VIRTUAL_ATTR');
                if (assessmentWarning) {
                    this.ModalService.delete(assessmentWarning.message)
                        .then(() => {
                            this.FormResource.deleteFormQuestion({ questionId, formId: this.form.id }).$promise
                                .then(() => {
                                    this.toastr.success(this.$translate.instant('forms.Question is removed from form'));
                                    this.$rootScope.$broadcast('updateQuestion');
                                }).catch(() => {
                                    this.toastr.error(this.$translate.instant('question.Question delete failed from form'));
                                });
                        });

                    return;
                }
                if (assessmentError) {
                    this.toastr.error(assessmentError.message);

                    return;
                }
                // any other validation error (e.g. the form is already answered) must still reach the user
                this.showRemoveError(errors && errors.data);
            })
        ;
    }

    /**
     * Show the validation message returned by the API, falling back to a generic one
     * @param errors
     */
    showRemoveError (errors) {
        const error = this.lodash.find(errors, (item) => item && item.message);

        this.toastr.error(error
            ? error.message
            : this.$translate.instant('question.Question delete failed from form'));
    }

    calculateWeight (question) {
        if (question.score > 0) {
            return parseFloat(((question.score / this.form.maxScore) * 100).toFixed(2));
        }

        return 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/form/questions/question/index.js